<template>
  <div class="range-scale">
    <!-- Current label -->
    <!-- <div class="current-label">
      {{ currentLabel }}
    </div> -->

    <!-- Slider -->
    <input
      type="range"
      :min="min"
      :max="max"
      step="1"
      v-model.number="internalValue"
      :disabled="disabled" 
    />
    <!-- Major tick labels -->
    <div class="all-labels" v-if="showAllLabels && majorTicks.length">
      <span
        v-for="(tick, index) in majorTicks"
        :key="index"
        :style="{ left: tick.position + '%' }"
        class="tick-label"
      >
        {{ tick.label }}
      </span>
    </div>

    <!-- Optional minor ticks -->
   
  </div>
</template>

<script>
export default {
  name: 'RangeScale',
  props: {
    value: { type: Number, default: null },
    min: { type: Number, required: true },
    max: { type: Number, required: true },
    labels: { type: Array, default: () => [] },
    showAllLabels: { type: Boolean, default: true },
    maxMajorTicks: { type: Number, default: 10 },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    internalValue: {
      get() {
        return this.value !== null ? this.value : this.min;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
currentLabel() {
  return this.internalValue;
},
majorTicks() {
  const range = this.max - this.min;

  if (range === 0) {
    return [{ value: this.min, position: 0, label: this.min }];
  }

  const maxTicks = 10;

  // Calculate rough step
  const roughStep = range / (maxTicks - 1);

  // Normalize to nice round numbers
  const magnitude = Math.pow(10, Math.floor(Math.log10(roughStep)));
  const residual = roughStep / magnitude;

  let niceStep;
  if (residual <= 1) niceStep = 1;
  else if (residual <= 2) niceStep = 2;
  else if (residual <= 5) niceStep = 5;
  else niceStep = 10;

  const step = niceStep * magnitude;

  // Start at a rounded minimum
  const niceMin = Math.ceil(this.min / step) * step;

  const ticks = [];

  for (let value = niceMin; value <= this.max; value += step) {
    ticks.push({
      value,
      position: ((value - this.min) / range) * 100,
      label: value
    });
  }

  // Ensure min & max ticks exist
if (!ticks.length || ticks[0].value !== this.min) {
  ticks.unshift({
    value: this.min,
    position: 0,
    label: this.min
  });
}

if (!ticks.length || ticks[ticks.length - 1].value !== this.max) {
  ticks.push({
    value: this.max,
    position: 100,
    label: this.max
  });
}

  return ticks.slice(0, maxTicks);
}
}
};
</script>

<style scoped>

.range-scale {
  position: relative;
  width: 100%;
  padding: 0 8px; /* or adjust to match slider thumb size */
}
input[type='range'] {
  width: 100%;
  box-sizing: border-box;
}
.current-label {
  margin-top: 4px;
  font-weight: bold;
  display: flex;
  justify-content: center;
}
.all-labels {
  position: relative;
  width: calc(100% - 16px); /* match padding */
  margin: 4px 8px 0 8px;   /* same as container padding */
  height: 20px;
}
.tick-label {
  position: absolute;
  transform: translateX(-50%);
  font-size: 12px;
  white-space: nowrap;
}
.minor-ticks {
  position: relative;
  width: 100%;
  height: 10px;
}
.minor-tick {
  position: absolute;
  width: 1px;
  height: 6px;
  background-color: #888;
  transform: translateX(-50%);
}
</style>
